module.exports = __webpack_public_path__ + "static/img/down.2299181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/down.png
// module id = G8zt
// module chunks = 0